import { TopAdminNav } from "../layouts/TopAdminNav";
import "../assets/css/activities.css";
import BackButton from "../components/backButton";
import {
  LogIn,
  NotebookPen,
  HeartPulse,
  Thermometer,
  Utensils,
  Droplets,
  Smile,
  Bed,
  Bath,
  StickyNote,
  Trophy,
  PackageSearch,
  LogOut,
  ChevronRight,
} from "lucide-react";
import { useState, useEffect } from "react";
import Swal from "sweetalert2";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { CAhomework } from "../pages/classActivities/CAhomework";
import { CAattitude } from "../pages/classActivities/CAattitude";
import { CAfood } from "../pages/classActivities/CAfood";
import { CAhealth } from "../pages/classActivities/CAhealth";
import { CAliquid } from "../pages/classActivities/CAliquid";
import { CAlogin } from "../pages/classActivities/CAlogin";
import { CAlogout } from "../pages/classActivities/CAlogout";
import { CAnotes } from "../pages/classActivities/CAnotes";
import { CAsleep } from "../pages/classActivities/CAsleep";
import { CAsport } from "../pages/classActivities/CAsport";
import { CAsupplies } from "../pages/classActivities/CAsupplies";
import { CAtemeperature } from "../pages/classActivities/CAtemperature";
import { CAtoilet } from "../pages/classActivities/CAtoilet";
import useWindowDimensions from "../hooks/useWindowSize";
import { defaultUrl } from "../features/actions";
import { makeFetchRequest, makePostRequest } from "../utilities/common";
import { uploadImageToCloudinary } from "../utilities/importantFns";
import PupilCard from "../components/ActivityCard";
import ActivityCard2 from "../components/ActivityCard2";
interface Student {
  id: string;
  fullName?: string;
  firstname?: string;
  othername: string;
  lastname?: string;
  surname: string;
  profile_picture: string;
  dob: string;
  age: string;
  classroom: {
    id: number;
    name: string;
  };
  classroom_id?: string;
  allergies: [];
}
interface Activity {
  type?: string;
  student_id?: string[];
  user_id?: string[];
  description?: string;
  time?: string;
  image?: string[];
  video?: string;
  doc?: string;
  meal?: string;
  quantity?: string;
  health?: string;
  observation?: string;
  liquid?: string;
  mood?: string;
  morale?: string;
  sport_type?: string;
  items_needed?: string;
  toilet_type?: string;
  condition?: string;
  temperature?: string;
}

const ClassActivities = () => {
  const { width: windowWidth } = useWindowDimensions();
  const isMobileScreen = windowWidth < 440;
  const [currentStage, setCurrentStage] = useState(1);

  /** STEP 1 & 2 - SELECT ACTIVITY & SELECT CHILDREN*/
  const [selectedActivity, setSelectedActivity] = useState("");
  const [selectedChildren, setSelectedChildren] = useState<string[]>([]);

  const [studentData, setStudentData] = useState<Student[]>([]);
  const [classrooms, setClassrooms] = useState([]);

  const fetchClassrooms = async () => {
    const response = await makeFetchRequest(
      `${defaultUrl}/classroom`,
      false,
      true,
    );
    setClassrooms(response || []);
    return response;
  };

  const fetchStudentData = async () => {
    const data = await makeFetchRequest(
      `${defaultUrl}/students/withoutPagination`,
      false,
      true,
    );
    const rawList = data;
    const fmtList =
      rawList &&
      rawList.map((item: Student, index: number) => {
        return {
          ...item,
          profile_picture: (
            <img
              style={{ height: "100%", width: "100%" }}
              src={item.profile_picture}
              alt="student"
            />
          ),
          fullName: `${item.firstname ?? ""} ${item.othername ?? ""} ${
            item.lastname ?? ""
          } ${item.surname ?? ""}`,
        };
      });
    // console.log(fmtList);
    setStudentData(fmtList);
  };

  function selectActivity(activity: string) {
    setSelectedActivity(activity);
    setCurrentStage(2);
  }
  function selectChild(childID: string) {
    if (selectedChildren.includes(childID)) {
      setSelectedChildren((prev) => {
        const filtered = prev.filter((child) => child !== childID);
        return filtered;
      });
    } else {
      setSelectedChildren((prev) => [...prev, childID]);
    }
  }
  function handleSelectAll() {
    if (
      (filteredData && filteredData.length) ===
      (selectedChildren && selectedChildren.length)
    ) {
      return setSelectedChildren([]);
    }
    const childrenIDs =
      filteredData &&
      filteredData.map((child) => {
        return child.id;
      });
    setSelectedChildren(childrenIDs);
  }

  /** STEP 3 - ACTIVITY FORM AND DATA UPLOAD*/
  const [formData, setFormData] = useState<Activity>({});

  function handleFormChange(name: string, value: string) {
    // console.log({[name]: value })
    setFormData((prev) => {
      return { ...prev, [name]: value };
    });
  }
  const [loading, setLoading] = useState(false);
  async function handleSubmitForm(e: any) {
    setLoading(true);
    e.preventDefault();

    formData.type = selectedActivity;
    formData.student_id = selectedChildren;

    try {
      // if media is available
      let imageString;
      let videoString;
      let docString;
      if (formData.image) {
        imageString = await uploadImageToCloudinary(
          formData.image[0] ? formData.image[0] : formData.image,
        );
        formData.image = [imageString];
      } else {
        formData.image = ["null"];
      }

      if (formData.video) {
        videoString = await uploadImageToCloudinary(formData.video);
        formData.video = videoString || "";
      } else {
        formData.video = "null";
      }

      if (formData.doc) {
        docString = await uploadImageToCloudinary(formData.doc);
        formData.doc = docString || "";
      }

      await makePostRequest(`${defaultUrl}/activity_feed/create`, formData);
      setFormData({});
      setLoading(false);
      setCurrentStage(1);
      setStudentData([]);
      // navigate("/staff/class/activities")
    } catch (error: any) {
      // console.log({ errror: error });
      setLoading(false);
      Swal.fire({
        title: `Error!`,
        text: `${error?.data?.message || error.response?.data?.message}`,
        icon: "error",
        showCancelButton: false,
        confirmButtonColor: "red",
        // cancelButtonColor: "red",
        confirmButtonText: "Try Again",
        // cancelButtonText: "Leave Page",
      });
    }
  }
  const ACTIVITIES = [
    {
      id: "login",
      name: "Log In",
      icon: LogIn,
      color: "text-emerald-500",
      bg: "bg-emerald-50",
    },
    {
      id: "homework",
      name: "Home Work",
      icon: NotebookPen,
      color: "text-blue-500",
      bg: "bg-blue-50",
    },
    {
      id: "health",
      name: "Health",
      icon: HeartPulse,
      color: "text-red-500",
      bg: "bg-red-50",
    },
    {
      id: "temperature",
      name: "Temperature",
      icon: Thermometer,
      color: "text-orange-500",
      bg: "bg-orange-50",
    },
    {
      id: "food",
      name: "Food",
      icon: Utensils,
      color: "text-amber-600",
      bg: "bg-amber-50",
    },
    {
      id: "liquids",
      name: "Liquid",
      icon: Droplets,
      color: "text-sky-500",
      bg: "bg-sky-50",
    },
    {
      id: "mood",
      name: "Mood",
      icon: Smile,
      color: "text-indigo-500",
      bg: "bg-indigo-50",
    },
    {
      id: "sleep",
      name: "Sleep",
      icon: Bed,
      color: "text-purple-500",
      bg: "bg-purple-50",
    },
    {
      id: "toilet",
      name: "Toilet",
      icon: Bath,
      color: "text-slate-500",
      bg: "bg-slate-50",
    },
    {
      id: "note",
      name: "Notes",
      icon: StickyNote,
      color: "text-yellow-600",
      bg: "bg-yellow-50",
    },
    {
      id: "activity",
      name: "Sport",
      icon: Trophy,
      color: "text-rose-500",
      bg: "bg-rose-50",
    },
    {
      id: "supplies",
      name: "Supplies",
      icon: PackageSearch,
      color: "text-cyan-600",
      bg: "bg-cyan-50",
    },
    {
      id: "logout",
      name: "Log Out",
      icon: LogOut,
      color: "text-red-600",
      bg: "bg-red-100",
    },
  ];
  /** FILTERINGS */
  const [searchTerm, setSearchTerm] = useState("");
  const [classRoomFilter, setClassRoomFilter] = useState("");
  const [filteredData, setFilteredData] = useState(studentData);

  function filterData() {
    const filtered =
      studentData &&
      studentData
        .filter((data) => {
          if (!searchTerm.length) {
            return data;
          }

          return data?.fullName
            ?.toLowerCase()
            .includes(searchTerm.toLowerCase());
        })
        .filter((data) => {
          if (!classRoomFilter.length) {
            return data;
          }

          return (
            data.classroom_id?.toLowerCase() === classRoomFilter.toLowerCase()
          );
        });

    // console.log({ filtered });
    return filtered;
  }

  useEffect(() => {
    const searchBar = document.getElementById("searchAttendanceInput");
    searchBar?.focus();
    fetchStudentData();
    fetchClassrooms();
  }, []);

  /** COMPONENT UPDATE */
  useEffect(() => {
    setFormData({});
    setFilteredData(filterData());
  }, [selectedActivity, studentData, searchTerm, classRoomFilter]);

  /** CONDITION STATEMENTS VARIABLES */
  const selectAllConditions =
    studentData &&
    studentData.length > 0 &&
    (studentData && studentData.length) ===
      (selectedChildren && selectedChildren.length);
  // console.log(formData);
  return (
    <div>
      <div className="w-full flex items-center">
        <BackButton />
        <TopAdminNav name="Jone Doe" title="Class management" />
      </div>

      {/* CURRENT STAGE 1 */}
      {currentStage === 1 && (
        <>
          <div className="cursor-pointer w-full md:w-1/2 my-2 flex items-center justify-between text-[14px] mlo">
            <h4>
              <span className="font-semibold text-blue-900">
                Select Activity
              </span>
              {" > "}
            </h4>
          </div>
          <div className="activities mt-4 pt-2 border-t-2 h-[80vh] !overflow-y-scroll register-scroll">
            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 h-[75vh] overflow-y-auto pr-2 custom-scrollbar">
              {ACTIVITIES.map((activity) => (
                <ActivityCard2
                  key={activity.id}
                  name={activity.name}
                  icon={activity.icon}
                  color={activity.color}
                  bgColor={activity.bg}
                  onClick={() => selectActivity(activity.id)}
                />
              ))}
            </div>
          </div>
        </>
      )}

      {/* CURRENT STAGE 1 */}
      {currentStage === 2 && (
        <div className="flex flex-col h-[85vh] max-h-[800px] bg-slate-50 rounded-[2.5rem] overflow-hidden border border-slate-200 shadow-xl">
          {/* --- STATIC HEADER --- */}
          <div className="p-6 pb-4 bg-white border-b border-slate-100">
            <div className="flex items-center gap-2 mb-4 text-xs font-bold uppercase tracking-widest">
              <span
                className="text-orange-500 cursor-pointer hover:underline"
                onClick={() => setCurrentStage(1)}
              >
                Activity
              </span>
              <span className="text-slate-300">/</span>
              <span className="text-blue-900">Select Pupils</span>
            </div>

            <div className="flex flex-col md:flex-row gap-4 items-center justify-between">
              {/* Select All Toggle */}
              <label
                className={`flex items-center gap-3 px-4 py-2 rounded-2xl border-2 transition-all cursor-pointer
          ${selectAllConditions ? "border-blue-600 bg-blue-50" : "border-slate-100 bg-slate-50"}
        `}
              >
                <input
                  type="checkbox"
                  checked={selectAllConditions}
                  onChange={handleSelectAll}
                  className="w-5 h-5 rounded-lg accent-blue-600"
                />
                <span className="text-sm font-bold text-slate-700">
                  Select All ({selectedChildren?.length})
                </span>
              </label>

              {/* Search & Filter Group */}
              <div className="flex items-center gap-2 w-full md:w-auto">
                <select
                  value={classRoomFilter}
                  onChange={(e) => setClassRoomFilter(e.target.value)}
                  className="hidden md:block bg-slate-50 border-none rounded-2xl px-4 py-2.5 text-sm font-bold text-slate-600 outline-none focus:ring-2 ring-blue-500/20"
                >
                  <option value="">All Classes</option>
                  {classrooms?.map((c: any) => (
                    <option key={c.id} value={c.id}>
                      {c.name}
                    </option>
                  ))}
                </select>

                <div className="relative flex-1 md:w-64">
                  <input
                    type="text"
                    placeholder="Search pupils..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className="w-full bg-slate-50 border-none rounded-2xl pl-10 pr-4 py-2.5 text-sm font-medium outline-none focus:ring-2 ring-blue-500/20"
                  />
                  <div className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400">
                    {/* Add Search Icon Here */}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* --- SCROLLABLE GRID --- */}
          <div className="flex-1 overflow-y-auto p-6 custom-scrollbar">
            <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-5 lg:grid-cols-6 gap-4 justify-items-center">
              {filteredData?.map((student, index) => (
                <PupilCard
                  key={index}
                  name={student.fullName ?? ""}
                  img={student.profile_picture}
                  selected={selectedChildren.includes(student.id)}
                  onClick={() => selectChild(student.id)}
                />
              ))}
            </div>
          </div>

          {/* --- STICKY FOOTER (Always Visible) --- */}
          <div className="p-6 bg-white border-t border-slate-100 flex items-center justify-between">
            <button
              onClick={() => setCurrentStage(1)}
              className="px-8 py-3 rounded-2xl font-bold text-slate-500 hover:bg-slate-50 transition-colors"
            >
              Back
            </button>

            <button
              disabled={selectedChildren?.length < 1}
              onClick={() => setCurrentStage(3)}
              className={`px-10 py-3 rounded-2xl font-bold text-white shadow-lg transition-all
          ${
            selectedChildren?.length < 1
              ? "bg-slate-300 cursor-not-allowed"
              : "bg-blue-600 hover:bg-blue-700 hover:shadow-blue-200 active:scale-95"
          }
        `}
            >
              Proceed with {selectedChildren?.length} Pupils
            </button>
          </div>
        </div>
      )}

      {currentStage === 3 && (
        <div>
          <div className="cursor-pointer w-full md:w-1/2 my-2 flex items-center justify-between text-[14px] mlo">
            <h4>
              <span
                className="underline font-semibold text-orange-500"
                onClick={() => setCurrentStage(1)}
              >
                Select Activity
              </span>
              {" > "}
              <span
                className="underline font-semibold text-orange-500"
                onClick={() => setCurrentStage(2)}
              >
                Select Pupils...
              </span>
              {" > "}
              <span className="font-semibold text-blue-900">Enter details</span>
            </h4>
          </div>
          <div className="">
            {selectedActivity === "homework" && (
              <CAhomework
                formData={formData}
                loading={loading}
                onFormChange={handleFormChange}
                onFormSubmit={handleSubmitForm}
              />
            )}
            {selectedActivity === "mood" && (
              <CAattitude
                loading={loading}
                formData={formData}
                onFormChange={handleFormChange}
                onFormSubmit={handleSubmitForm}
              />
            )}
            {selectedActivity === "food" && (
              <CAfood
                formData={formData}
                loading={loading}
                onFormChange={handleFormChange}
                onFormSubmit={handleSubmitForm}
              />
            )}
            {selectedActivity === "health" && (
              <CAhealth
                formData={formData}
                loading={loading}
                onFormChange={handleFormChange}
                onFormSubmit={handleSubmitForm}
              />
            )}
            {selectedActivity === "liquids" && (
              <CAliquid
                formData={formData}
                loading={loading}
                onFormChange={handleFormChange}
                onFormSubmit={handleSubmitForm}
              />
            )}
            {selectedActivity === "login" && (
              <CAlogin
                formData={formData}
                loading={loading}
                onFormChange={handleFormChange}
                onFormSubmit={handleSubmitForm}
              />
            )}
            {selectedActivity === "logout" && (
              <CAlogout
                formData={formData}
                loading={loading}
                onFormChange={handleFormChange}
                onFormSubmit={handleSubmitForm}
              />
            )}
            {selectedActivity === "note" && (
              <CAnotes
                formData={formData}
                loading={loading}
                onFormChange={handleFormChange}
                onFormSubmit={handleSubmitForm}
              />
            )}
            {selectedActivity === "sleep" && (
              <CAsleep
                formData={formData}
                loading={loading}
                onFormChange={handleFormChange}
                onFormSubmit={handleSubmitForm}
              />
            )}
            {selectedActivity === "activity" && (
              <CAsport
                formData={formData}
                loading={loading}
                onFormChange={handleFormChange}
                onFormSubmit={handleSubmitForm}
              />
            )}
            {selectedActivity === "supplies" && (
              <CAsupplies
                formData={formData}
                loading={loading}
                onFormChange={handleFormChange}
                onFormSubmit={handleSubmitForm}
              />
            )}
            {selectedActivity === "temperature" && (
              <CAtemeperature
                formData={formData}
                loading={loading}
                onFormChange={handleFormChange}
                onFormSubmit={handleSubmitForm}
              />
            )}
            {selectedActivity === "toilet" && (
              <CAtoilet
                formData={formData}
                loading={loading}
                onFormChange={handleFormChange}
                onFormSubmit={handleSubmitForm}
              />
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default ClassActivities;
